import RfiActivityAdditionalFiles from './RfiActivityAdditionalFiles.component';

export default RfiActivityAdditionalFiles;
